<template>
  <div class="checkout-form verify-init">
    <verification
      :user="user"
      :addresses="shipping_addresses"
      :securityCheck="securityCheck"
      :personaEnvironment="personaEnvironment"
      :personaTemplateId="personaTemplateId"
      :personaEnvironmentId="personaEnvironmentId"
      :verificationOpened="true"
      :returningCustomer="false"
      :collapsed="false"
    />
  </div>
</template>

<script>

import CheckoutVerification from "../checkout/steps/verification";

export default {
  name: 'AccountVerifyInit',
  props: {
    user: { type: Object, required: true },
    shipping_addresses: { type: Array, required: true },
    personaEnvironment: { type: String, required: true },
    personaTemplateId: { type: String, required: true },
    personaEnvironmentId: { type: String, required: true },
  },
  components: {
    Verification: CheckoutVerification
  },
  data() {
    return {
      securityCheck: {
        shipping: false,
        verification: false,
        billing: false,
        terms: false,
        disclosure: false,
        creditConsent: false
      },
    };
  },
}
</script>
